module.exports = __webpack_public_path__ + "static/media/bullet-icons.3225ed76.png";